<template>
    <div class="mt-15">
        <div v-if="bloqueo==0">
            <v-row>
                <v-col cols="12" class="mt-10 text-center">
                    <img src="@/assets/denegado.png" />
                </v-col>
            </v-row>
        </div>
        <div v-else>
        <v-container>
            <v-row class="mt-2">
                <v-col cols="12" md="8">
                    <v-row>
                        <v-col cols="12" md="8">
                            <v-row class="mt-2">
                                <v-col cols="8" md="5">
                                    <v-text-field class='text-body-2' v-model="usuario" label="Usuario" outlined dense rounded></v-text-field>
                                </v-col>
                                <v-col cols="4" md="2">
                                    <v-btn @click="searchUser()" class="mt-1" small color="teal" dark rounded><v-icon small>search</v-icon></v-btn>
                                </v-col>
                                <v-col cols="12" md="12" class="mt-n5">
                                    <v-alert class='text-body-2' v-if="existe=='si'" shaped dense text type="success">
                                        Existe !!!
                                    </v-alert>
                                    <v-alert class='text-body-2' v-else-if="existe=='no'" shaped dense text type="warning">
                                        Nueva !!!
                                    </v-alert>
                                    <v-alert class='text-body-2' v-else dense shaped text type="info">
                                        Selecciona Usuario !!!
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="8" class="mt-n7">
                                    <v-text-field class='text-body-2' v-model="nombre" label="Nombre" outlined dense rounded :filled="filled" :disabled="disabled"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="8" class="mt-n7">
                                    <v-text-field class='text-body-2' v-model="email" label="Email" outlined dense rounded :filled="filled" :disabled="disabled"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>   
                                <v-col cols="7" md="4" class="mt-n7">
                                    <v-select @change="cambiaTipo(tipo)" class='text-body-2' v-model="tipo" :items="tipos" label="Tipo" dense outlined rounded :filled="filled" :disabled="disabled"></v-select>
                                </v-col>
                                <v-col cols="5" md="4" class="mt-n7">
                                    <v-text-field @keypress="onlyDecimal" class='text-body-2' v-model="comision" label="Comision (%)" outlined dense rounded :filled="filled" :disabled="disabled"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-row>
                                <v-col cols="12" md="12" class="text-center">
                                    <form method="post" action="#" enctype="multipart/form-data">
                                        <div>
                                            <img src="https://www.centrystore.cl/user-blue.png" alt="avatar" id="img" />
                                            <input type="file" name="archivo" id="archivo" accept="image/*" /><br/>
                                            <label for="archivo" style="border-radius: 25px; font-size:10pt">Cambiar Foto</label>
                                        </div>
                                    </form>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="2"></v-col>
                                <v-col cols="12" md="8">
                                    <v-select class='text-body-2' v-model="estado" :items="estados" label="Estado" dense outlined rounded :filled="filled" :disabled="disabled"></v-select>
                                </v-col>
                                <v-col cols="12" md="2"></v-col>
                            </v-row>
                            <v-row class="mt-n5">
                                <v-col cols="12" md="12" class="text-center">
                                    <v-badge :content="content" color="indigo">
                                        <v-chip @click="openServices()">
                                            <strong class="text-caption indigo--text">SERVICIOS</strong>
                                        </v-chip>
                                    </v-badge>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="4">
                    <div class="mt-n2">
                        <h5>PERMISOS</h5>
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-row>
                                    <v-col cols="6" md="6">
                                        <h5 class="mt-5 primary--text">Venta Servicio</h5>
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-col cols="6" md="6">
                                        <v-switch v-model="permiso_1" dense></v-switch>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n15">
                            <v-col cols="12" md="12">
                                <v-row>
                                    <v-col cols="6" md="6">
                                        <h5 class="mt-5 primary--text">Venta Producto</h5>
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-col cols="6" md="6">
                                        <v-switch v-model="permiso_2" dense></v-switch>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n15">
                            <v-col cols="12" md="12">
                                <v-row>
                                    <v-col cols="6" md="6">
                                        <h5 class="mt-5 primary--text">Flujo Caja</h5>
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-col cols="6" md="6">
                                        <v-switch v-model="permiso_3" dense></v-switch>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n15">
                            <v-col cols="12" md="12">
                                <v-row>
                                    <v-col cols="6" md="6">
                                        <h5 class="mt-5 primary--text">Agenda Solarium</h5>
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-col cols="6" md="6">
                                        <v-switch v-model="permiso_4" dense></v-switch>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n15">
                            <v-col cols="12" md="12">
                                <v-row>
                                    <v-col cols="6" md="6">
                                        <h5 class="mt-5 primary--text">Liquidaciones</h5>
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-col cols="6" md="6">
                                        <v-switch v-model="permiso_5" dense></v-switch>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n15">
                            <v-col cols="12" md="12">
                                <v-row>
                                    <v-col cols="6" md="6">
                                        <h5 class="mt-5 primary--text">Usuarios</h5>
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-col cols="6" md="6">
                                        <v-switch v-model="permiso_6" dense></v-switch>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>
                    <v-row class="mt-n15">
                        <v-col cols="12" md="12">
                            <v-row>
                                <v-col cols="6" md="6">
                                    <h5 class="mt-5 primary--text">Servicios</h5>
                                    <v-divider></v-divider>
                                </v-col>
                                <v-col cols="6" md="6">
                                    <v-switch v-model="permiso_7" dense></v-switch>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row class="mt-n15">
                        <v-col cols="12" md="12">
                            <v-row>
                                <v-col cols="6" md="6">
                                    <h5 class="mt-5 primary--text">Clientes</h5>
                                    <v-divider></v-divider>
                                </v-col>
                                <v-col cols="6" md="6">
                                    <v-switch v-model="permiso_8" dense></v-switch>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row class="mt-n15">
                        <v-col cols="12" md="12">
                            <v-row>
                                <v-col cols="6" md="6">
                                    <h5 class="mt-5 primary--text">Productos</h5>
                                    <v-divider></v-divider>
                                </v-col>
                                <v-col cols="6" md="6">
                                    <v-switch v-model="permiso_9" dense></v-switch>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row class="mt-n15">
                        <v-col cols="12" md="12">
                            <v-row>
                                <v-col cols="6" md="6">
                                    <h5 class="mt-5 primary--text">Forma de Pago</h5>
                                    <v-divider></v-divider>
                                </v-col>
                                <v-col cols="6" md="6">
                                    <v-switch v-model="permiso_10" dense></v-switch>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row class="mt-n15">
                        <v-col cols="12" md="12">
                            <v-row>
                                <v-col cols="6" md="6">
                                    <h5 class="mt-5 primary--text">Reportes</h5>
                                    <v-divider></v-divider>
                                </v-col>
                                <v-col cols="6" md="6">
                                    <v-switch v-model="permiso_11" dense></v-switch>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row class="mt-n15">
                        <v-col cols="12" md="12">
                            <v-row>
                                <v-col cols="6" md="6">
                                    <h5 class="mt-5 grey--text">Otro</h5>
                                    <v-divider></v-divider>
                                </v-col>
                                <v-col cols="6" md="6">
                                    <v-switch v-model="permiso_12" dense disabled></v-switch>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-container>
                <v-divider class="mt-4"></v-divider>
                <v-row class="mt-3">
                    <v-col cols="12" md="4">
                        <v-chip small dark @click="resetPass()">Resetear Contraseña</v-chip>
                    </v-col>
                    <v-col cols="6" md="2">
                        <v-btn @click="clsInput()" color="teal" rounded dark small block>Nuevo</v-btn>
                    </v-col>
                    <v-col cols="6" md="2">
                        <v-btn @click="dataUser()" color="teal" rounded dark small block>Grabar</v-btn>
                    </v-col>
                    <v-col cols="12" md="2"></v-col>
                </v-row>
            </v-container>
        </v-container>
    </div>
        <div style="height: 50px;"></div>
        <v-footer fixed color="#c1680e" height="50"></v-footer>

        <!-- dialog servicios --> 
        <v-dialog v-model="d_services" transition="dialog-bottom-transition" max-width="600" persistent>
        <v-card>
            <v-card-title>
                <v-btn @click="d_services=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                <strong class="ml-5 text-body-2">Servicios</strong>
            </v-card-title>
            <v-card-text>
                <div class="mt-5">
                    <v-simple-table fixed-header dense height="300">
                        <thead>
                            <tr>
                                <th style="background-color: lightgrey;">ID</th>
                                <th style="background-color: lightgrey;">Servicio</th>
                                <th style="background-color: lightgrey;" class="text-center">Detalle</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr @click="handleUser(item)" v-for="item in services" :key="item.ID">
                                <td><span class="text-body-2">{{ item.ID }}</span></td>
                                <td><span class="text-body-2">{{ item.Descripcion }}</span></td>
                                <td class="text-center">                                        
                                    <v-chip small color="indigo" dark>{{ item.content }}</v-chip>
                                    <v-icon class="ml-5">navigate_next</v-icon>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                <v-row class="mt-n5">
                    <v-col cols="12" class="text-center">
                        <v-btn @click="updateServices()" color="teal" rouded dark small rounded dense>Actualizar Servicios</v-btn>
                    </v-col>
                </v-row>

            </v-card-text>
        </v-card>
        </v-dialog>

        <!-- dialog detalle --> 
        <v-dialog v-model="d_detail" transition="dialog-bottom-transition" max-width="600" persistent>
        <v-card>
            <v-card-title>
                <v-btn @click="d_detail=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                <strong class="ml-5 text-body-2 teal--text">{{ txt_service.toUpperCase() }}</strong>
            </v-card-title>
            <v-card-text>
                <div class="mt-5">
                    <v-simple-table fixed-header dense height="300">
                        <thead>
                            <tr>
                                <th style="background-color: lightgrey;">Detalle</th>
                                <th style="background-color: lightgrey;" class="text-center">Ck</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr @click="ck_line(item)" v-for="item in detailservice" :key="item.ID">
                                <td v-if="parseInt(item.Id_Servicio)==parseInt(id_service)"><span class="text-body-2">{{ item.Descripcion }}</span></td>
                                <td v-if="parseInt(item.Id_Servicio)==parseInt(id_service) && item.ck!=true" class="text-center"><v-icon small>check_box_outline_blank</v-icon></td>
                                <td v-if="parseInt(item.Id_Servicio)==parseInt(id_service) && item.ck!=false" class="text-center"><v-icon color="success" small>check_box</v-icon></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </v-card-text>
        </v-card>
        </v-dialog>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>

            </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
form img{
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 6px solid #AAA;
}
form div:first-child{
  align-items: center;
}
form div:first-child input{
  display: none;
}
form div:first-child label{
  background: #1F5F74;
  color: white;
  padding: 6px 20px;
  cursor: pointer;
  border-radius: 3px;
}
form input{
  padding: 8px 20px;
  border: 1px solid #AAA;
  border-radius: 3px;
}
</style>
<script>
import axios from "axios";
export default {
  name: 'Usuarios',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,
    snack:false,
    color_snack:'',
    mensaje:'',
    existe:'',
    filled:true,
    disabled:true,

    usuario:'',
    nombre:'',
    email:'',
    comision:0,
    foto:'',
    permiso_1:false,
    permiso_2:false,
    permiso_3:false,
    permiso_4:false,
    permiso_5:false,
    permiso_6:false,
    permiso_7:false,
    permiso_8:false,
    permiso_9:false,
    permiso_10:false,
    permiso_11:false,
    permiso_12:false,

    estado:'',
    estados:['V','N'],
    tipo:'',
    tipos:['Usuario','Profesional','Administrador'],
    bloqueo:null,
    loading:false,

    services:[],
    detailservice:[],
    myservices:[],
    d_services:false,
    id_service:0,
    txt_service:'',
    d_detail:false,
    content:0,

  }),
  async mounted(){
    const myToken = localStorage.getItem('mytoken');
    const myUser = localStorage.getItem('myuser');
    const myContrato = localStorage.getItem('mycontrato');
    const myTime = localStorage.getItem('timeuser');
    if(myToken!=null && myUser!=null && myContrato!=null){
      //verificamos la expiracion
      const ahora = new Date();
      const expira = new Date(myTime);
      if(ahora > expira){
        this.goLogin()
      } else {
        this.apikey = myToken;
        this.contrato = myContrato;
        this.user = myUser;
        this.loading=true;
        //listener de la foto
        const defaultFile = 'https://www.centrystore.cl/user-blue.png';
        const file = document.getElementById( 'archivo' );
        const img = document.getElementById( 'img' );
        file.addEventListener( 'change', e => {
            if( e.target.files[0] ){
                const reader = new FileReader( );
                reader.onload = function( e ){
                    img.src = e.target.result;
                }
                reader.readAsDataURL(e.target.files[0]);                       
            }else{
                img.src = defaultFile;
            }        
        });
        this.bloqueo = await this.myPermiso(6);
        if(parseInt(this.bloqueo)!=0){
            await this.searchServicios();
            await this.searchDetailService();
        };
        this.loading=false
      }
    } else {
        this.goLogin();
    }
  },
  methods:{
    async openServices(){
        console.log(this.existe);
        if(this.existe=='si'){
            this.d_services=true
        } else {
            this.color_snack='error';
            this.mensaje='Seleccione Usuario';
            this.snack=true
        }
    },
    async searchServicios(){
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.apikey
            };
            const params = {
                'contrato' : this.contrato,
                'user' : this.user,
                'id' : 'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/services/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                console.log('Services', datos);
                datos.forEach(element => {
                    this.services.push({
                        'ID': element.ID,
                        'Descripcion': element.Descripcion,
                        'content': 0
                    })
                });
            }
        } catch (error) {
            console.log(error)
        }
    },
    async handleUser(line){
        if(this.myservices.length!=0){
            this.myservices.forEach(element => {
                const filter = this.detailservice.filter(res => parseInt(res.ID)==parseInt(element.Id_Detalle));
                if(filter.length!=0){
                    filter.ck=true;
                }
            });
        }
        this.id_service = line.ID;
        this.txt_service = line.Descripcion;
        this.d_detail=true;
    },
    async searchDetailService(){
        try {
            this.detailservice=[];
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.apikey
            };
            const params = {
                'contrato' : this.contrato,
                'user' : this.user,
                'id' : 'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/detail/services/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                console.log('Detail', datos);
                datos.forEach(element => {
                    this.detailservice.push({
                        'ID': element.ID,
                        'Id_Servicio': element.Id_Servicio,
                        'Descripcion': element.Descripcion,
                        'ck': false
                    })                    
                })
            }
        } catch (error) {
            console.log(error)
        };
    },
    async searchServiceUser(){
        try {
            //restablecer los servvicios en 0
            this.services.forEach(element => { element.content = 0 });
            //restablecer el ck del detail
            this.detailservice.forEach(element => { element.ck = false });
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.apikey
            };
            const params = {
                'contrato' : this.contrato,
                'user' : this.user,
                'usuario' : this.usuario
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/user/services/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                console.log('Services User', datos);
                this.myservices=datos;
                let total_service = 0;
                //seleccionamos el ck del detail service
                this.myservices.forEach(element => {
                    const filter = this.detailservice.filter(res => 
                        parseInt(res.ID) == parseInt(element.Id_Detalle) && 
                        parseInt(res.Id_Servicio) == parseInt(element.Id_Servicio)
                    );
                    if(filter.length!=0){ 
                        filter[0].ck = true;
                        //sumar servicio
                        const servi = this.services.filter(res => parseInt(res.ID) == parseInt(element.Id_Servicio));
                        if(servi.length!=0){
                            const cantidad = servi[0].content;
                            const suma_servicio = parseInt(cantidad) + 1;
                            servi[0].content = suma_servicio;
                            total_service = parseInt(total_service) + 1;
                        }
                    }
                });
                this.content = total_service;
            }
        } catch (error) {
            console.log(error)
        };
    },
    ck_line(line){
        console.log(line);
        if(line.ck==false){ 
            line.ck=true;
            this.content = parseInt(this.content) + 1;
            //sumar servicio
            const servi = this.services.filter(res => parseInt(res.ID) == parseInt(line.Id_Servicio));
            const cantidad = servi[0].content;
            const suma_servicio = parseInt(cantidad) + 1;
            servi[0].content = suma_servicio;
        } else {
            line.ck=false
            this.content = parseInt(this.content) - 1;
            //resta servicio
            const servi = this.services.filter(res => parseInt(res.ID) == parseInt(line.Id_Servicio));
            const cantidad = servi[0].content;
            const resta_servicio = parseInt(cantidad) - 1;
            if(resta_servicio!=0){ 
                servi[0].content = resta_servicio
            } else {
                servi[0].content = 0
            } 
        }
    },
    goLogin(){
      localStorage.removeItem('mytoken');
      localStorage.removeItem('myuser');
      localStorage.removeItem('mycontrato');
      localStorage.removeItem('timeuser');
      this.$router.push({name:'Login'})
    },
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.apikey
            };
            const params = {
                'contrato' : this.contrato,
                'user' : this.user,
                'id' : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    clsInput(){
        this.existe='';
        this.filled=true;
        this.disabled=true;
        this.usuario='';
        this.nombre='';
        this.email='';
        this.comision=0;
        this.foto='';
        this.permiso_1=false;
        this.permiso_2=false;
        this.permiso_3=false;
        this.permiso_4=false;
        this.permiso_5=false;
        this.permiso_6=false;
        this.permiso_7=false;
        this.permiso_8=false;
        this.permiso_9=false;
        this.permiso_10=false;
        this.permiso_11=false;
        this.permiso_12=false;
        this.estado='';
        this.tipo='';
        const img = document.getElementById( 'img' );
        img.src = 'https://www.centrystore.cl/user-blue.png';
        this.content=0;
        this.myservices=[];
    },
    async searchUser(){
        this.loading=true;
        if(this.usuario!='all'){
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' :  this.user,
                    'usuario' :  this.usuario
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/user/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    const element = datos[0];
                    this.tipo = element.tipo;
                    this.nombre = element.nombre;
                    this.email = element.email;
                    this.comision = element.comision;
                    this.foto = element.foto;
                    if(this.foto!=''){
                        //insertar foto
                        const img = document.getElementById( 'img' );
                        img.src = this.foto;
                    };
                    this.permiso_1 = this.boleanPermiso(element.permiso_01);
                    this.permiso_2 = this.boleanPermiso(element.permiso_02);
                    this.permiso_3 = this.boleanPermiso(element.permiso_03);
                    this.permiso_4 = this.boleanPermiso(element.permiso_04);
                    this.permiso_5 = this.boleanPermiso(element.permiso_05);
                    this.permiso_6 = this.boleanPermiso(element.permiso_06);
                    this.permiso_7 = this.boleanPermiso(element.permiso_07);
                    this.permiso_8 = this.boleanPermiso(element.permiso_08);
                    this.permiso_9 = this.boleanPermiso(element.permiso_09);
                    this.permiso_10 = this.boleanPermiso(element.permiso_10);
                    this.permiso_11 = this.boleanPermiso(element.permiso_11);
                    this.permiso_12 = this.boleanPermiso(element.permiso_12);
                    this.estado = element.estado;
                    this.existe='si';
                    this.filled=false;
                    this.disabled=false;
                    await this.searchServiceUser();
                } else {
                    if(datos[0].existe=='no'){
                        this.existe='no';
                        this.filled=false;
                        this.disabled=false;
                    } else {
                        this.color_snack='error';
                        this.mensaje='Inconsistencia en los datos, informar a soporte';
                        this.snack=true
                    }
                }
            } catch (error) {
                console.log(error);
                this.color_snack='error';
                this.mensaje='Algo salio mal, informar a soporte';
                this.snack=true
            }
        }
        this.loading=false;
    },
    codePermiso(bolean){
        if(bolean){ return 1 } else { return 0 }
    },
    boleanPermiso(code){
        if(code==1){ return true } else { return false }
    },
    onlyDecimal ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },
    async dataUser(){
        console.log(this.existe)
        if(this.existe=="si"){ await this.updateUser() };
        if(this.existe=="no"){ await this.saveUser() };
        await this.saveServices();
    },
    async saveServices(){
        try {
             const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            if(this.detailservice.length!=0){
                for (let index = 0; index < this.detailservice.length; index++) {
                    const element = this.detailservice[index];
                    //verificamos si existe ese servicio de ese cliente
                    const found = this.myservices.filter(res => 
                        parseInt(res.Id_Detalle) == parseInt(element.ID) && 
                        parseInt(res.Id_Servicio) == parseInt(element.Id_Servicio)
                    );
                    const params = {
                        contrato : this.contrato,
                        user: this.user,
                        usuario: this.usuario,
                        id_servicio: element.Id_Servicio ,
                        id_detalle: element.ID,
                    };
                    if(found.length!=0){
                        if(element.ck!=true){
                            //eliminamos el servicio
                            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/delete/user/services/',params,{headers});
                            const datos = res.data;
                            console.log('delete service')
                            if(datos[0].existe=='si'){
                                console.log('servicio eliminado')
                            }
                        }
                    } else {
                        if(element.ck!=false){
                            //se graba el servicio
                            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/user/services/',params,{headers});
                            const datos = res.data;
                            console.log('save service', datos)
                            if(datos[0].existe=='si'){
                                console.log('servicio grabado')
                            }
                        }
                    }
                }
            }
        } catch (error) {
           console.log(error) 
        };
    },
    async updateServices(){
        this.loading=true;
        try {
             const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            if(this.detailservice.length!=0){
                for (let index = 0; index < this.detailservice.length; index++) {
                    const element = this.detailservice[index];
                    //verificamos si existe ese servicio de ese cliente
                    const found = this.myservices.filter(res => 
                        parseInt(res.Id_Detalle) == parseInt(element.ID) && 
                        parseInt(res.Id_Servicio) == parseInt(element.Id_Servicio)
                    );
                    const params = {
                        contrato : this.contrato,
                        user: this.user,
                        usuario: this.usuario,
                        id_servicio: element.Id_Servicio ,
                        id_detalle: element.ID,
                    };
                    if(found.length!=0){
                        if(element.ck!=true){
                            //eliminamos el servicio
                            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/delete/user/services/',params,{headers});
                            const datos = res.data;
                            console.log('delete service')
                            if(datos[0].existe=='si'){
                                console.log('servicio eliminado')
                            }
                        }
                    } else {
                        if(element.ck!=false){
                            //se graba el servicio
                            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/user/services/',params,{headers});
                            const datos = res.data;
                            console.log('save service', datos)
                            if(datos[0].existe=='si'){
                                console.log('servicio grabado')
                            }
                        }
                    }
                };
                this.color_snack='success';
                this.mensaje='Servicios del usuario actualizados';
                this.snack=true
            }
        } catch (error) {
           console.log(error) 
        };
        this.loading=false;
    },
    async saveUser(){
        this.loading=true;
        try {
            //obtener valor foto
            const img = document.getElementById( 'img' );
            this.foto = img.src;

            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user: this.user,
                usuario: this.usuario,
                clave: '123456',
                tipo: this.tipo,
                nombre: this.nombre,
                email: this.email,
                comision: this.comision,
                foto: this.foto,
                permiso_01: this.codePermiso(this.permiso_1),
                permiso_02: this.codePermiso(this.permiso_2),
                permiso_03: this.codePermiso(this.permiso_3),
                permiso_04: this.codePermiso(this.permiso_4),
                permiso_05: this.codePermiso(this.permiso_5),
                permiso_06: this.codePermiso(this.permiso_6),
                permiso_07: this.codePermiso(this.permiso_7),
                permiso_08: this.codePermiso(this.permiso_8),
                permiso_09: this.codePermiso(this.permiso_9),
                permiso_10: this.codePermiso(this.permiso_10),
                permiso_11: this.codePermiso(this.permiso_11),
                permiso_12: this.codePermiso(this.permiso_12),
                estado: this.estado
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/user/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.color_snack='success';
                this.mensaje='Usuario grabado con exito';
                this.snack=true
            } else {
                this.color_snack='error';
                this.mensaje='No es posible grabar al usuario';
                this.snack=true
            }
        } catch (error) {
            console.log(error)
            this.color_snack='error';
            this.mensaje='Algo salio mal, informar a soporte';
            this.snack=true
        }
        this.loading=false
    },
    async updateUser(){
        this.loading=true;
        try {
            //obtener valor foto
            const img = document.getElementById( 'img' );
            this.foto = img.src;

            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user: this.user,
                usuario: this.usuario,
                tipo: this.tipo,
                nombre: this.nombre,
                email: this.email,
                comision: this.comision,
                foto: this.foto,
                permiso_01: this.codePermiso(this.permiso_1),
                permiso_02: this.codePermiso(this.permiso_2),
                permiso_03: this.codePermiso(this.permiso_3),
                permiso_04: this.codePermiso(this.permiso_4),
                permiso_05: this.codePermiso(this.permiso_5),
                permiso_06: this.codePermiso(this.permiso_6),
                permiso_07: this.codePermiso(this.permiso_7),
                permiso_08: this.codePermiso(this.permiso_8),
                permiso_09: this.codePermiso(this.permiso_9),
                permiso_10: this.codePermiso(this.permiso_10),
                permiso_11: this.codePermiso(this.permiso_11),
                permiso_12: this.codePermiso(this.permiso_12),
                estado: this.estado
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/user/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.color_snack='success';
                this.mensaje='Usuario actaulizado con exito';
                this.snack=true
            } else {
                this.color_snack='error';
                this.mensaje='No es posible grabar al usuario';
                this.snack=true
            }
        } catch (error) {
            console.log(error)
            this.color_snack='error';
            this.mensaje='Algo salio mal, informar a soporte';
            this.snack=true
        }
        this.loading=false;
    },
    async resetPass(){
        this.loading=true;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user: this.user,
                clave: '123456',
                usuario: this.usuario,
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/reset/user/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.color_snack='success';
                this.mensaje='Clave reseteada con exito';
                this.snack=true
            } else {
                this.color_snack='error';
                this.mensaje='No es posible resetear clave';
                this.snack=true
            }
        } catch (error) {
            console.log(error);
            this.color_snack='error';
            this.mensaje='Algo salio mal, informar a soporte';
            this.snack=true
        }
        this.loading=false;
    },
    cambiaTipo(t){
        if(this.existe=='no'){
            if(t=='Administrador'){
                this.permiso_1 = true;
                this.permiso_2 = true;
                this.permiso_3 = true;
                this.permiso_4 = true;
                this.permiso_5 = true;
                this.permiso_6 = true;
                this.permiso_7 = true;
                this.permiso_8 = true;
                this.permiso_9 = true;
                this.permiso_10 = true;
                this.permiso_11 = true;
                this.permiso_12 = true;
            } else {
                this.permiso_1 = false;
                this.permiso_2 = false;
                this.permiso_3 = false;
                this.permiso_4 = false;
                this.permiso_5 = false;
                this.permiso_6 = false;
                this.permiso_7 = false;
                this.permiso_8 = false;
                this.permiso_9 = false;
                this.permiso_10 = false;
                this.permiso_11 = false;
                this.permiso_12 = false;
            }
        }
    }





  }
}
</script>
